const getDiagnostic = (): any => {
  const cordova = (globalThis as any).cordova;
  return cordova && cordova.plugins && cordova.plugins.diagnostic ? cordova.plugins.diagnostic : undefined;
}

/** Whether the app runs on a device, where it can send people to its own page in the system settings. */
export const canOpenNativeSettings = (): boolean => {
  return !!getDiagnostic();
}

/**
 * Opens the app's page in the system settings. Once a permission has been refused for good, the OS
 * stops asking, and that page is the only place left to turn it back on.
 */
export const openNativeSettings = () => {
  const diagnostic = getDiagnostic();
  if (diagnostic) {
    diagnostic.switchToSettings();
  }
}



// WEBPACK FOOTER //
// ./src/helpers/nativeSettings.ts